import { render, staticRenderFns } from "./TicketAssignmentInterface.vue?vue&type=template&id=cdc5446a&scoped=true"
import script from "./TicketAssignmentInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketAssignmentInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TicketAssignmentInterface.vue?vue&type=style&index=0&id=cdc5446a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc5446a",
  null
  
)

export default component.exports